// extracted by mini-css-extract-plugin
export default {"button":"IxdcQ8w","icon":"lqk0GNt"};